import { render, staticRenderFns } from "./TeachDocuments.vue?vue&type=template&id=5c312e1f&"
import script from "./TeachDocuments.vue?vue&type=script&lang=js&"
export * from "./TeachDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports